export default __webpack_public_path__ + "static/media/rocket-white.de578639.png";